export default {

 badge: "Learning Methodology",
    title: "A Complete Ecosystem; Beyond Just a Book!",
    subtitle: "We turn language learning into an interactive, fun, and memorable journey with 5 core integrated tools.",
    missionTitle: "Our Mission: Deep Learning Without Boredom",
    missionDesc: "All resources are crafted according to international standards for kids aged 4 to 14.",
    ctaBtn: "Explore Courses",
    items: [
      {
        title: "Native Audio",
        desc: "Authentic pronunciation and listening practice tailored for kids",
        icon: "bi-headphones",
        theme: "theme-coral",
      },
      {
        title: "Video Lessons",
        desc: "Animated visual lessons for effortless concept retention",
        icon: "bi-play-circle-fill",
        theme: "theme-cyan",
      },
      {
        title: "Learning Games",
        desc: "Gamified activities to reinforce vocabulary effortlessly",
        icon: "bi-controller",
        theme: "theme-yellow",
      },
      {
        title: "Printable Sheets",
        desc: "Hands-on worksheets for writing and fine-motor development",
        icon: "bi-pencil-square",
        theme: "theme-green",
      },
      {
        title: "Smart Quizzes",
        desc: "Fun progress checks to boost learner confidence",
        icon: "bi-trophy-fill",
        theme: "theme-purple",
      },
    ],


};
